import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import { HttpClient} from '@angular/common/http'
import { Observable } from 'rxjs';

@Injectable()
export class ConfiguracaoService {


  constructor(
    private http: HttpClient
  ){ }



    getConfiguracaoByChave(chave: string):Promise<any>{
      return this.carregarConfiguracaoByChave(chave).toPromise().then((resposta:any) => resposta);
    }


    public carregarConfiguracaoByChave(chave: string):Observable<any>{
      const headers = {
        'Content-Type': 'application/json'
      };       
      return this.http.get(environment.urlBackend +  environment.getConfiguracaoPorChave + chave, {headers})
    }


}
